import { useMutation } from "@apollo/client";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { Button } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { DELETE_CAMPAIGN } from "../../../graphql/mutations";

export default function RestoreCampaing({ open, handleClose, id }) {
  // Setting mutation
  const [restoreCampaign, { loading }] = useMutation(DELETE_CAMPAIGN);
  const { enqueueSnackbar } = useSnackbar();

  const handleRestore = (id) => {
    restoreCampaign({
      variables: {
        id: id,
        restore: true,
      },
    }).then(() => (window.location.href = "/campanhas"));
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle id="scroll-dialog-title">Restaurar Campanha</DialogTitle>

        <DialogContent>
          <p>Deseja realmente restaurar a campanha?</p>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={() => {
              handleRestore(id);
              enqueueSnackbar("Campanha restaurada com sucesso!");
            }}
            variant="contained"
            color="primary"
            disabled={loading}
          >
            {loading && (
              <CircularProgress size={14} style={{ marginRight: 12 }} />
            )}
            Restaurar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
